<template>
    <v-toolbar 
        flat 
        dense
    >
        <DownloadDialog
            :selected-tickets="selectedTickets"
        />
        <SendTicketDialog
            :selected-tickets="selectedTickets"
        />
        <PrintTicketsDialog
            :selected-tickets="selectedTickets"
        />
        <!-- CWTM-636 feature hidden
        <v-icon
            class="mr-7"
            :disabled="differencesDisabled"
            @click="emitCompare"
        >
            mdi-compare
        </v-icon> -->      
        <v-icon
            class="material-icons-outlined mr-7"
            :disabled="reopenDisabled"            
            @click="emitReopen"
        >
            lock_open
        </v-icon>
        <v-btn
            class="ma-1 action-btn text-subtitle-2"
            depressed
            color="primary"
            :disabled="respondDisabled"
            @click="emitRespond"
        >
            <v-icon
                left
                class="action-icon"
            >
                reply
            </v-icon>
            Respond
        </v-btn>
        <v-btn
            class="ma-1 action-btn text-subtitle-2"
            depressed
            color="primary"
            :disabled="assignDisabled"
            @click="emitAssign"
        >
            <v-icon
                left
                dark
                class="material-icons-outlined action-icon"
            >
                assignment_turned_in
            </v-icon>
            Assign
        </v-btn>
        <TicketMapNavButtons />
    </v-toolbar>
</template>
<script>
import DownloadDialog from './TicketsDownload.vue';
import SendTicketDialog from './TicketsSend.vue';
import PrintTicketsDialog from './PrintTickets';
import TicketMapNavButtons from './Map/TicketMapNavButtons';

export default {
    components: {
        DownloadDialog,
        SendTicketDialog,
        PrintTicketsDialog,
        TicketMapNavButtons,
    },
    props: {
        selectedTickets: {
            type: Array,
            default: () => [],
        },
        differencesDisabled: {
            type: Boolean,
        },
        reopenDisabled: {
            type: Boolean
        },
        respondDisabled: {
            type: Boolean
        },
        assignDisabled: {
            type: Boolean
        },    
    },
    data: () => ({
        tableMapToggle: 'table',
    }),
    methods: {
        emitCompare() {
            this.$emit('open-compare-dialog');
        },
        emitReopen() {
            this.$emit('open-reopen-dialog');
        },
        emitRespond() {
            this.$emit('open-respond-dialog');
        },
        emitAssign() {
            this.$emit('open-assign-dialog');
        }
    }
};
</script>